import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

import { RADIO_SIZE, BOX_SHADOW_SIZE } from './constants';

const Radio = ({ value, name, id, onChange, ariaLabel, isChecked, className, children }) => (
  <>
    <label className={ClassNames('Radio', className)} htmlFor={id}>
      <span className="Radio__input">
        <input
          className="Radio__input-input"
          type="radio"
          name={name}
          onChange={onChange}
          value={value}
          id={id}
          aria-label={ariaLabel}
          checked={isChecked}
        />
        <span className="Radio__control" />
      </span>
      {children && <span className="Radio__label">{children}</span>}
    </label>

    <style jsx>
      {`
        .Radio {
          display: flex;
        }

        .Radio:hover {
          cursor: pointer;
        }

        .Radio__input {
          display: flex;
          align-items: center;
        }

        .Radio__input-input {
          opacity: 0;
          width: 0;
          height: 0;
          margin: 0;
        }

        .Radio__control {
          display: grid;
          place-items: center;
          width: ${RADIO_SIZE}px;
          height: ${RADIO_SIZE}px;
          border-radius: 50%;
          border: 1px solid ${Theme.get('colors-black')};
        }

        .Radio__label {
          margin-left: ${Theme.get('spacing') * 2}px;
          font-weight: ${Theme.get('font-weight-normal')};
          font-size: ${Theme.get('font-size')}px;
          transform: translateY(1px);
        }

        .Radio__input-input + .Radio__control::before {
          content: '';
          width: ${BOX_SHADOW_SIZE}px;
          height: ${BOX_SHADOW_SIZE}px;
          box-shadow: inset ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 2}px
            ${Theme.get('colors-black')};
          border-radius: 50%;
          transform: scale(0);
        }

        .Radio__input-input:checked + .Radio__control::before {
          transform: scale(1);
        }

        .Radio__input-input:focus + .Radio__control {
          box-shadow: 0 0 0 1px ${Theme.get('colors-black')};
        }
      `}
    </style>
  </>
);

Radio.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

Radio.defaultProps = {
  isChecked: false,
  className: null,
  children: null,
  onChange: () => {},
};

export default Radio;
